// Example: 'Developer notes for Arabic' -> 'developer-notes-for-arabic'.
export const getHeadingSlug = (text: string): string =>
  text
    .toLowerCase()
    .replace(/[^\p{L}\p{N}_\s-]/gu, '')
    .trim()
    .replace(/\s+/g, '-');
